module.exports = __webpack_public_path__ + "static/media/system_advantages.600f0c55.png";